<template>
  <div class="product-list-container">
    <div class="header">
      <div class="filter-box">
        <div class="custom-row row w-75">
          <div class="col col-lg-5 col-md-5 col-xs-12">
            <search-input
              v-model="SearchProduct"
              placeholder="Search for product"
              class="search-input white_space"
            />
          </div>
          <div class="show-active-items marg-top" >
            <input
              type="checkbox"
              id="show-active"
              class="active-checkbox "
              v-model="isActive"
            />
            <label for="show-active" >Active Only</label>
          </div>
        </div>
      </div>
      <div
          @click="$router.push({ name: 'system-admin-add-route-product' })"
          class="" >
        <primary-button class="primary-button ">Add Product</primary-button>
      </div>
    </div>
    <loader :loading="loading" v-if="loading" />
    <template v-if="!loading">
      <not-found v-if="isFound" />
      <div
        v-else
        class="table_div"
        style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th class="product-name">
                Product Name
                <span v-on:click="sorting('up', 'product_name')" class="sorting"
                  >&#8593;</span
                >
                <span
                  v-on:click="sorting('down', 'product_name')"
                  class="sorting"
                  >&#8595;</span
                >
              </th>
              <th class="created-on">
                Created On
                <span v-on:click="sorting('up', 'created_on')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'created_on')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <th class="created-by">Created By</th>
              <th class="type">Type</th>
              <th class="action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="product in products"
              :key="product.productId"
              :class="{
                active: product.status === 'active',
                inactive: product.status === 'inactive',
              }"
            >
              <th class="user_active product-name">
                <div @click="changeStatus(product)" class="status"></div>
                {{ product.productName }}
              </th>
              <th class="user_active created-on">{{ product.createdOn }}</th>
              <th class="user_active image created-by">
                {{ product.createdBy }}
              </th>
              <th class="user_active type">{{ product.state }}</th>

              <th class="action d-flex h-100">
                <span title="Add">
                  <svg
                        @click="
                    $router.push({
                      name: 'system-admin-add-route-product-company',
                      params: { id: product.productId },
                    })
                  "
                        class="svg-grey"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                >
                  <path
                          d="M24.3729268,11.5098362 C24.6872358,11.5098362 24.9420325,11.7664181 24.9420325,12.0830302 C24.9420325,12.3996422 24.6872358,12.656306 24.3729268,12.656306 L23.8378862,12.656306 L23.8378862,24.3593233 C23.8378862,24.6759353 23.5830894,24.9325991 23.2687805,24.9325991 L6.67325203,24.9325991 C6.35894309,24.9325991 6.10414634,24.6759353 6.10414634,24.3593233 L6.10414634,12.656306 L5.56910569,12.656306 C5.25479675,12.656306 5,12.3996422 5,12.0830302 C5,11.7664181 5.25479675,11.5097543 5.56910569,11.5097543 L9.78341463,11.5097543 L9.78341463,6.58220259 C9.78341463,6.26559052 10.0382114,6.00892672 10.3525203,6.00892672 L19.5895122,6.00892672 C19.9038211,6.00892672 20.1586179,6.26559052 20.1586179,6.58220259 L20.1586179,11.5098362 L24.3729268,11.5098362 Z M17.7754472,23.7861293 L17.7754472,22.8598793 L15.5401626,22.8598793 L15.5401626,23.7212672 C15.5401626,23.7432155 15.5386179,23.7648362 15.5362602,23.7861293 L17.7754472,23.7861293 Z M14.4057724,23.7861293 C14.4034146,23.7647543 14.4019512,23.7432155 14.4018699,23.7212672 L14.4018699,22.8598793 L12.1665854,22.8598793 L12.1665854,23.7861293 L14.4057724,23.7861293 Z M18.9136585,23.7861293 L22.6996748,23.7861293 L22.6996748,12.6563879 L7.24235772,12.6563879 L7.24235772,23.7861293 L11.028374,23.7861293 L11.028374,22.2866034 C11.028374,21.9699914 11.2831707,21.7133276 11.5974797,21.7133276 L18.3445528,21.7133276 C18.6588618,21.7133276 18.9136585,21.9699914 18.9136585,22.2866034 L18.9136585,23.7861293 Z M10.921626,7.15547845 L10.921626,11.5097543 L19.0204065,11.5097543 L19.0204065,7.15547845 L10.921626,7.15547845 Z M9.39243902,17.497375 C9.70682927,17.497375 9.96154472,17.7540388 9.96154472,18.0706509 L9.96154472,19.0657759 C9.96154472,19.3823879 9.70674797,19.6390517 9.39243902,19.6390517 C9.07813008,19.6390517 8.82333333,19.3823879 8.82333333,19.0657759 L8.82333333,18.0706509 C8.82333333,17.7540388 9.07813008,17.497375 9.39243902,17.497375 Z M11.6689431,17.497375 C11.9833333,17.497375 12.2380488,17.7540388 12.2380488,18.0706509 L12.2380488,19.0657759 C12.2380488,19.3823879 11.983252,19.6390517 11.6689431,19.6390517 C11.3546341,19.6390517 11.0998374,19.3823879 11.0998374,19.0657759 L11.0998374,18.0706509 C11.0998374,17.7540388 11.3546341,17.497375 11.6689431,17.497375 Z M13.9455285,17.497375 C14.2598374,17.497375 14.5146341,17.7540388 14.5146341,18.0706509 L14.5146341,19.0657759 C14.5146341,19.3823879 14.2598374,19.6390517 13.9455285,19.6390517 C13.6312195,19.6390517 13.3764228,19.3823879 13.3764228,19.0657759 L13.3764228,18.0706509 C13.3764228,17.7540388 13.6312195,17.497375 13.9455285,17.497375 Z M15.9965041,17.497375 C16.310813,17.497375 16.5656098,17.7540388 16.5656098,18.0706509 L16.5656098,19.0657759 C16.5656098,19.3823879 16.310813,19.6390517 15.9965041,19.6390517 C15.6821951,19.6390517 15.4273984,19.3823879 15.4273984,19.0657759 L15.4273984,18.0706509 C15.4273984,17.7540388 15.6821951,17.497375 15.9965041,17.497375 Z M18.2730894,17.497375 C18.5873984,17.497375 18.8421951,17.7540388 18.8421951,18.0706509 L18.8421951,19.0657759 C18.8421951,19.3823879 18.5873984,19.6390517 18.2730894,19.6390517 C17.9587805,19.6390517 17.7039837,19.3823879 17.7039837,19.0657759 L17.7039837,18.0706509 C17.7039837,17.7540388 17.9587805,17.497375 18.2730894,17.497375 Z M20.5495935,17.497375 C20.8639024,17.497375 21.1186992,17.7540388 21.1186992,18.0706509 L21.1186992,19.0657759 C21.1186992,19.3823879 20.8639024,19.6390517 20.5495935,19.6390517 C20.2352846,19.6390517 19.9804878,19.3823879 19.9804878,19.0657759 L19.9804878,18.0706509 C19.9804878,17.7540388 20.2352846,17.497375 20.5495935,17.497375 Z M9.39243902,14.2972672 C9.70682927,14.2972672 9.96154472,14.553931 9.96154472,14.8705431 L9.96154472,15.8656681 C9.96154472,16.1822802 9.70674797,16.438944 9.39243902,16.438944 C9.07813008,16.438944 8.82333333,16.1822802 8.82333333,15.8656681 L8.82333333,14.8705431 C8.82333333,14.553931 9.07813008,14.2972672 9.39243902,14.2972672 Z M11.6689431,14.2972672 C11.9833333,14.2972672 12.2380488,14.553931 12.2380488,14.8705431 L12.2380488,15.8656681 C12.2380488,16.1822802 11.983252,16.438944 11.6689431,16.438944 C11.3546341,16.438944 11.0998374,16.1822802 11.0998374,15.8656681 L11.0998374,14.8705431 C11.0998374,14.553931 11.3546341,14.2972672 11.6689431,14.2972672 Z M13.9455285,14.2972672 C14.2598374,14.2972672 14.5146341,14.553931 14.5146341,14.8705431 L14.5146341,15.8656681 C14.5146341,16.1822802 14.2598374,16.438944 13.9455285,16.438944 C13.6312195,16.438944 13.3764228,16.1822802 13.3764228,15.8656681 L13.3764228,14.8705431 C13.3764228,14.553931 13.6312195,14.2972672 13.9455285,14.2972672 Z M15.9965041,14.2972672 C16.310813,14.2972672 16.5656098,14.553931 16.5656098,14.8705431 L16.5656098,15.8656681 C16.5656098,16.1822802 16.310813,16.438944 15.9965041,16.438944 C15.6821951,16.438944 15.4273984,16.1822802 15.4273984,15.8656681 L15.4273984,14.8705431 C15.4273984,14.553931 15.6821951,14.2972672 15.9965041,14.2972672 Z M18.2730894,14.2972672 C18.5873984,14.2972672 18.8421951,14.553931 18.8421951,14.8705431 L18.8421951,15.8656681 C18.8421951,16.1822802 18.5873984,16.438944 18.2730894,16.438944 C17.9587805,16.438944 17.7039837,16.1822802 17.7039837,15.8656681 L17.7039837,14.8705431 C17.7039837,14.553931 17.9587805,14.2972672 18.2730894,14.2972672 Z M20.5495935,14.2972672 C20.8639024,14.2972672 21.1186992,14.553931 21.1186992,14.8705431 L21.1186992,15.8656681 C21.1186992,16.1822802 20.8639024,16.438944 20.5495935,16.438944 C20.2352846,16.438944 19.9804878,16.1822802 19.9804878,15.8656681 L19.9804878,14.8705431 C19.9804878,14.553931 20.2352846,14.2972672 20.5495935,14.2972672 Z M12.6944715,8.44166379 C13.0087805,8.44166379 13.2635772,8.69832759 13.2635772,9.01493966 L13.2635772,10.0100647 C13.2635772,10.3266767 13.0087805,10.5833405 12.6944715,10.5833405 C12.3801626,10.5833405 12.1253659,10.3266767 12.1253659,10.0100647 L12.1253659,9.01493966 C12.1253659,8.69832759 12.3801626,8.44166379 12.6944715,8.44166379 Z M14.9710569,8.44166379 C15.2853659,8.44166379 15.5401626,8.69832759 15.5401626,9.01493966 L15.5401626,10.0100647 C15.5401626,10.3266767 15.2853659,10.5833405 14.9710569,10.5833405 C14.656748,10.5833405 14.4019512,10.3266767 14.4019512,10.0100647 L14.4019512,9.01493966 C14.4019512,8.69832759 14.656748,8.44166379 14.9710569,8.44166379 Z M17.2476423,8.44166379 C17.5619512,8.44166379 17.816748,8.69832759 17.816748,9.01493966 L17.816748,10.0100647 C17.816748,10.3266767 17.5619512,10.5833405 17.2476423,10.5833405 C16.9333333,10.5833405 16.6785366,10.3266767 16.6785366,10.0100647 L16.6785366,9.01493966 C16.6785366,8.69832759 16.9333333,8.44166379 17.2476423,8.44166379 Z"
                          id="path-1"
                  />
                </svg>
                </span>
                <span title="Edit">
                  <svg
                        @click="
                    $router.push({
                      name: 'system-admin-edit-route-product',
                      params: { id: product.productId },
                    })
                  "
                        class="svg-grey"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                >
                  <path
                          d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                          id="path-1"
                  />
                </svg>
                </span>
                <span title="Delete">
                  <svg
                        @click="deleteProduct(product)"
                        class="svg-grey delete"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                >
                  <path
                          d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                          id="path-1"
                  />
                </svg>
                </span>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col col-lg-7 col-md-7 col-xs-12 per-page">
        <span class="filter_by">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item, key) in pages" :key="key">
              {{ item }}
            </option>
          </primary-select>
        </div>
      </div>
      <div class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="totalPage"
          :perPage="per_page"
          :qnt="products.length"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    A11yDialog: () => import("@/components/A11yDialog.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  computed: {
    ...mapGetters({
      getProducts: "products/getProducts",
      totalPage: "products/getTotalPages",
    }),
    products() {
      return this.getProducts.map((product) => ({
        productName: product.product_name,
        createdOn: format(product.created_on, "YYYY:MM:DD HH:mm:ss"),
        createdBy: product.created_by,
        ownedBy: product.company_name,
        productId: product.product_uuid,
        routingId: product.routing_uuid,
        rateTableId: product.rate_table_uuid,
        status: product.status,
        state: product.public === true ? "public" : "private",
      }));
    },
    loading() {
      return this.$store.getters["products/getLoading"];
    },
  },
  data: () => ({
    product: [],
    rate_table: [],
    rates: [],
    routing: [],
    vendor_product: [],
    vendor_rates: [],
    SearchProduct: "",
    Page: 0,
    dialog: null,
    rate_table_uuid: null,
    routing_uuid: null,
    pages: [10, 50, 100],
    per_page: 10,
    isFound: false,
    isActive: false,
  }),
  created() {
    this.getAllProducts();
  },
  watch: {
    SearchProduct: function () {
      this.Page = 0;
      this.getAllProducts();
    },
    isActive() {
      this.Page = 0;
      this.getAllProducts();
    },
  },
  methods: {
    ...mapActions({
      viewAllProducts: "products/getProductList",
      delete: "products/deleteProduct",
      edit: "products/editProduct",
    }),
    changePerPage(e) {
      this.Page = 0;
      this.getAllProducts();
    },
    changePage(page) {
      this.Page = page;
      this.getAllProducts();
    },
    sorting(type, sortBy) {
      let order_dir = "";
      if (type === "up") {
        order_dir = "desc";
      } else {
        order_dir = "asc";
      }

      this.order_dir = order_dir;
      this.order_by = sortBy;

      this.getAllProducts(order_dir, sortBy);
    },
    getAllProducts(order_dir = "desc", order_by = "created_on") {
      this.isFound = false;
      this.viewAllProducts({
        is_active: this.isActive,
        page: this.Page,
        product_name: this.SearchProduct,
        perPage: this.per_page ? parseInt(this.per_page) : 10,
        order_dir: order_dir,
        order_by: order_by,
      }).then((res) => {
        console.log(res);
        if (!res.length) {
          this.isFound = true;
        }
      });
    },
    async changeStatus(product) {
      try {
        await this.edit({
          id: product.productId,
          product: {
            status: product.status === "active" ? "inactive" : "active",
          },
        });
        this.$snotify.success(
          `Product status has been changed from ${
            product.status === "active" ? "active" : "inactive"
          } to ${product.status === "active" ? "inactive" : "active"}`,
          {
            timeout: 6000,
          }
        );
      } catch (err) {
        this.$snotify.error(err.response.data, { timeout: 6000 });
      }
    },
    deleteProduct: async function (product) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this product!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then(async (result) => {
        if (!result.value) {
          return;
        }

        try {
          await this.delete({
            product_uuid: product.productId,
            rate_table_uuid: product.rateTableId,
            routing_uuid: product.routingId,
          });
          this.$swal("Deleted!", "Your product has been deleted.", "success");
        } catch (err) {
          this.$error(err);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sorting {
  font-size: 18px;
  cursor: pointer;
  margin: 0;
}
.per-page {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 0;
}
.perPage {
  width: 120px;
  display: inline-block;
}
.custom-row {
  width: 100%;
  display: flex;

  .show-active-items {
    display: flex;
    align-items: center;
    margin-left: 20px;

    .active-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      
    }
    label {
      margin-bottom: 0;
    }
  }
}
span {
  margin-right: 10px;
}

.table_div {
  .Invoice_table {
    width: 100%;
    margin: 21px auto 0;

    th {
      text-align: center;
    }
    .product-name {
      width: 250px;
    }
    .created-on {
      width: 160px;
    }
    .created-by {
      width: 150px;
    }
    .type {
      width: 100px;
    }
    .action {
      width: 125px;
    }
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 22%;
}
table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
.Invoice_table tbody tr th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 7px 10px 7px 20px;
  text-align: left;
}
table tr th {
  padding: 7px 10px 7px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.Invoice_table_popup {
  height: 30px;
  text-align: right;
  position: relative;
  padding: 0;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}

table thead th:first-child {
  padding-left: 35px;
}
tbody th:first-child {
  padding: 5px 10px 5px 0;
  span {
    padding: 7px 0;
  }
}
tbody th.created_by {
  line-height: 20px;
  height: 20px;
  padding: 7px 0 27px 0;
}
.svg-grey {
  fill: #55616e;
  margin-left: 3px;
}
div.buttons-wrapper {
  width: 100%;
  justify-content: flex-end;
}
@media (max-width: 891px) {
  .right-wrapprr {
    width: 100% !important;
  }
}
@media (max-width: 767px) {
  .header {
    display: block !important;
    height: auto !important;
  }
  .custom-row {
    width: 100% !important;
  }
  .buttons-wrapper {
    width: 100%;
    justify-content: flex-start !important;
    margin-top: 15px;
  }
  .primary-button {
    margin-top: 15px;
  }
}
@media (max-width: 600px) {
  .custom-row {
    display: block !important;
  }

  .buttons-wrapper {
    width: 100% !important;
  }
  .col-lg-6.col-md-7.col-xs-12 {
    margin-top: 15px;
  }
}
.user_active.image span {
  width: 30px;
  height: 30px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}
.buttons-wrapper {
  display: flex;
  align-items: center;
  width: fit-content;
}
.filter-box {
  display: flex;
  width: 100%;
  span {
    margin-left: 20px;
    margin-right: 12px;
    margin-top: 7px;
  }
}
.perPage {
  width: 120px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
  margin-bottom: 20px;
  .search-input {
    /*max-width: 345px;*/
    height: 100%;
    background-color: #ffffff;
  }
  .primary-button {
    height: 40px;
    width: 140px;
  }
}

.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 0 10px 0 12px;
  float: left;
}
.active {
  th .status {
    background-color: #24e2b8;
  }
}
.inactive {
  // background-color: #f0f1fa;
  th .status {
    background-color: #d2305b;
  }
}
.radio-button.active {
  padding: 2px 3px 3px 23px;
  background-color: #24e2b8;
  border: 0;
}
.radio-button {
  height: 30px;
  width: 50px;
  border-radius: 15px;
  background-color: #ffffff;
  border: 1px solid #a6b6be;
  margin-left: 10px;
  padding: 2px 23px 3px 3px;
  display: inline-block;
  margin-right: 5px;
  cursor: pointer;
}
th.icon .radio-button svg {
  height: 24px;
  width: 24px;
}
@media (max-width: 1320px) {
  .product-list-container table.Invoice_table {
    width: 1020px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
@media (max-width: 600px) {
   .marg-top{
     margin-top: 20px!important;
   }
}
</style>

